import React, { useEffect, useState } from "react";
import { Bell, LogOut } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { fmtDateTime } from "../lib/dates";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "./ui/popover";

export function AppHeader({ title, subtitle }) {
  const { logout, user } = useAuth();
  const [notifs, setNotifs] = useState([]);

  const load = () => api.get("/notifications").then((r) => setNotifs(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);

  const unread = notifs.filter((n) => !n.read).length;
  const markRead = () => api.post("/notifications/read").then(load);

  return (
    <header className="sticky top-0 z-30 bg-white/95 backdrop-blur-md border-b border-slate-200 px-4 lg:px-8 py-3 flex items-center justify-between w-full">
      <div className="flex items-center gap-2.5">
        <div className="h-9 w-9 rounded-xl copper-gradient flex items-center justify-center text-white font-display font-black text-lg lg:hidden">C</div>
        <div>
          <h1 className="font-display text-lg font-bold leading-none text-slate-900">{title}</h1>
          {subtitle && <p className="text-xs text-slate-400 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      <div className="flex items-center gap-1">
        <Popover onOpenChange={(o) => o && unread && markRead()}>
          <PopoverTrigger asChild>
            <button data-testid="notification-bell" className="relative p-2 rounded-xl hover:bg-slate-100 transition-colors">
              <Bell className="h-5 w-5 text-slate-600" />
              {unread > 0 && (
                <span className="absolute top-1 right-1 h-4 min-w-4 px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">
                  {unread}
                </span>
              )}
            </button>
          </PopoverTrigger>
          <PopoverContent align="end" className="w-80 p-0 max-h-96 overflow-y-auto">
            <div className="px-4 py-3 border-b font-bold text-sm">Notifications</div>
            {notifs.length === 0 ? (
              <p className="p-6 text-center text-sm text-slate-400">No notifications yet.</p>
            ) : (
              notifs.map((n) => (
                <div key={n.id} className="px-4 py-3 border-b last:border-0 text-sm">
                  <p className="text-slate-800">{n.message}</p>
                  <p className="text-xs text-slate-400 mt-0.5">{fmtDateTime(n.created_at)}</p>
                </div>
              ))
            )}
          </PopoverContent>
        </Popover>
        <button data-testid="logout-button" onClick={logout} className="p-2 rounded-xl hover:bg-slate-100 transition-colors">
          <LogOut className="h-5 w-5 text-slate-600" />
        </button>
      </div>
    </header>
  );
}
